import { Routes } from '@angular/router';
import { ShellComponent } from './core/layout/shell.component';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { RedirectComponent } from './core/redirect/redirect.component';
import { DashboardShellComponent } from './core/layout-v2/dashboard-shell.component';

export const routes: Routes = [
  { path: '', component: RedirectComponent, pathMatch: 'full' },
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: 'landing',
        loadComponent: () =>
          import('./features/landing/landing.component').then(
            (m) => m.LandingComponent
          ),
      },
      {
        path: 'features',
        loadComponent: () =>
          import('./pages/public/features/features-page.component').then(
            (m) => m.FeaturesPageComponent
          ),
      },
      {
        path: 'pricing',
        loadComponent: () =>
          import('./pages/public/pricing/pricing-page.component').then(
            (m) => m.PricingPageComponent
          ),
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./pages/public/contact/contact-page.component').then(
            (m) => m.ContactPageComponent
          ),
      },
      {
        path: 'about',
        loadComponent: () =>
          import('./pages/public/about/about-page.component').then(
            (m) => m.AboutPageComponent
          ),
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('./pages/public/legal/privacy-page.component').then(
            (m) => m.PrivacyPageComponent
          ),
      },
      {
        path: 'terms',
        loadComponent: () =>
          import('./pages/public/legal/terms-page.component').then(
            (m) => m.TermsPageComponent
          ),
      },
      {
        path: 'support',
        loadComponent: () =>
          import('./pages/public/support/support-page.component').then(
            (m) => m.SupportPageComponent
          ),
      },
      {
        path: 'auth/login',
        loadComponent: () =>
          import('./features/auth/login/login.component').then(
            (m) => m.LoginComponent
          ),
      },
      {
        path: 'auth/forgot-password',
        loadComponent: () =>
          import('./features/auth/forgot-password/forgot-password.component'),
      },
      {
        path: 'auth/signup',
        loadComponent: () =>
          import('./features/auth/signup/signup.component').then(
            (m) => m.SignupComponent
          ),
      },
      {
        path: 'accept-invite/:code',
        loadComponent: () =>
          import('./features/auth/accept-invite/accept-invite.component').then(
            (m) => m.AcceptInviteComponent
          ),
      },
    ],
  },
  {
    path: '',
    canActivate: [authGuard],
    component: DashboardShellComponent,
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
      },
      {
        path: 'loads',
        loadComponent: () =>
          import('./pages/loads/loads-list/loads-list.component').then(
            (m) => m.LoadsListComponent
          ),
      },
      {
        path: 'loads/:id',
        loadComponent: () =>
          import('./pages/loads/load-details/load-details-page.component').then(
            (m) => m.LoadDetailsPageComponent
          ),
      },
      {
        path: 'partners',
        loadComponent: () =>
          import('./pages/partners/partners-list/partners-list.component').then(
            (m) => m.PartnersListComponent
          ),
      },
      {
        path: 'fleet',
        loadComponent: () =>
          import('./pages/fleet/fleet-list/fleet-list.component').then(
            (m) => m.FleetListComponent
          ),
      },
      {
        path: 'drivers',
        loadComponent: () =>
          import('./pages/drivers/drivers-list/drivers-list.component').then(
            (m) => m.DriversListComponent
          ),
      },
      {
        path: 'drivers/:id',
        loadComponent: () =>
          import(
            './pages/drivers/driver-details/driver-details-page.component'
          ).then((m) => m.DriverDetailsPageComponent),
      },
      // S4: Driver ↔ dispatch chat
      {
        path: 'messages',
        loadComponent: () =>
          import('./pages/messages/messages-page.component').then(
            (m) => m.MessagesPageComponent
          ),
      },
      {
        path: 'team',
        loadComponent: () =>
          import('./pages/team/team-list/team-list.component').then(
            (m) => m.TeamListComponent
          ),
      },
      {
        path: 'invoicing',
        canActivate: [roleGuard(['root', 'admin', 'accounting'])],
        loadComponent: () =>
          import('./pages/invoicing/invoicing.component').then(
            (m) => m.InvoicingComponent
          ),
      },
      {
        path: 'payroll',
        // dispatch_manager: read-only (approve/finalize gated by PayrollService.canWritePayroll)
        canActivate: [roleGuard(['root', 'admin', 'accounting', 'dispatch_manager'])],
        loadComponent: () =>
          import('./pages/payroll/payroll.component').then(
            (m) => m.PayrollComponent
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./pages/settings/settings.component').then(
            (m) => m.SettingsComponent
          ),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./pages/notifications/notifications-page.component').then(
            (m) => m.NotificationsPageComponent
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
